<script>
  import config from "./config.json";
  const point = POINT || "ves";
  const location = config[[point]];
  const env = MODE || "dev";
  import Faces from './Faces.svelte';
  import Details from './Details.svelte';
  import Thanks from './Thanks.svelte';
  import {screen, name, space} from './stores';
  $name = location.name;
  $space = point;

</script>

<main>
	{#if $screen === 0}
	<Faces></Faces>
	{:else if $screen === 1}
	<Details></Details>
	{:else}
	<Thanks></Thanks>
	{/if}
</main>

<style>
</style>